import LabelCreateStep from './LabelCreateStep';

export default LabelCreateStep;
